import { ApiService } from '../../../services/api.service';
import { ProfileListDetailComponent } from "../profile-list-detail/profile-list-detail.component";
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
var ProfileListComponent = (function () {
    function ProfileListComponent(apiService, translate) {
        this.apiService = apiService;
        this.translate = translate;
        this.itemsPerPage = 40;
        this.searchUsername = '';
        this.groups = [];
        this.currentPage = 1;
        this.loading = false;
        this.list = [];
    }
    ProfileListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translate.onLangChange.subscribe(function (res) {
            _this.loadGroups();
        });
        this.loadGroups();
        this.loadData();
    };
    ProfileListComponent.prototype.reload = function () {
        this.pageChanged();
    };
    ProfileListComponent.prototype.pageChanged = function () {
        this.loadData();
    };
    ProfileListComponent.prototype.optionChanged = function () {
        this.search();
    };
    ProfileListComponent.prototype.openModal = function (data, index) {
        this.detailModal.open(this, data);
    };
    ProfileListComponent.prototype.search = function () {
        this.currentPage = 1;
        this.loadData();
    };
    ProfileListComponent.prototype.loadData = function () {
        var _this = this;
        var data = {
            page: this.currentPage,
            items_per_page: this.itemsPerPage,
            username: this.searchUsername
        };
        if (this.searchGroup != null)
            data['group'] = this.searchGroup;
        this.loading = true;
        this.apiService.getUsers(data).subscribe(function (res) {
            _this.list = res.results;
            _this.totalItems = res.count;
            _this.loading = false;
        }, function (error) {
            _this.loading = false;
        });
    };
    ProfileListComponent.prototype.clearSearch = function () {
        this.searchGroup = null;
        this.searchUsername = '';
        this.search();
    };
    ProfileListComponent.prototype.loadGroups = function () {
        var _this = this;
        this.groups = [{
                'label': this.translate.instant('COMMON.ALL'),
                'value': null
            }];
        this.apiService.getGroups().subscribe(function (groups) {
            _.forEach(groups, function (group) {
                _this.groups.push({
                    'label': group['name'],
                    'value': group['id']
                });
            });
            _this.groups = _.uniqBy(_this.groups, 'label');
        }, function (error) {
            console.log('error', error);
        });
    };
    return ProfileListComponent;
}());
export { ProfileListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-list/profile-list.component.ts.pre-build-optimizer.js